import React, { Component, useState, useRef, useEffect } from 'react';


import {
    // Navigate,
    useNavigate,
} from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import '../99_untils/i18n/';
// import SEOHelmet from '../99_untils/SEOHelmet';
import {
    Button, Container, Row, Col,
    // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import gsap from "gsap";

import './MiniGame.css';

// import AppNavi from '../Navigation/Navigation';
// import Footer from '../Footer/Footer';
// import TaxiGameIntro from '../02_TaxiGame/TaxiGameIntro';

import apiURLs from '../99_untils/apiURLs';

import LoadingIndicator from "../99_untils/LoadingIndicator";

import minaPoseIdol01 from '../images/idols/Mina_1_thumb.png';
import chaeyoungPoseIdol01 from '../images/idols/Chaeyoung_1_thumb.png';
import dahyunPoseIdol01 from '../images/idols/Dahyun_1_thumb.png';
import jeongyeonPoseIdol01 from '../images/idols/Jeongyeon_1_thumb.png';
import jihyoPoseIdol01 from '../images/idols/Jihyo_1_thumb.png';
import momoPoseIdol01 from '../images/idols/Momo_1_thumb.png';
import nayeonPoseIdol01 from '../images/idols/Nayeon_1_thumb.png';
import sanaPoseIdol01 from '../images/idols/Sana_1_thumb.png';
import tzuyuPoseIdol01 from '../images/idols/Tzuyu_1_thumb.png';

import BPPoseIdol01 from '../images/idols/blackpink_01_thumb.png';
import jenniePoseIdol01 from '../images/idols/jennie_01.png';
import jisooPoseIdol01 from '../images/idols/jisoo_01.png';
import lisaPoseIdol01 from '../images/idols/lisa_01.png';
import rosePoseIdol01 from '../images/idols/rose_01.png';

import IconMusic from './IconMusic';

import rankNum01 from './images/rank_nums/rank_nums_01.png';
import rankNum02 from './images/rank_nums/rank_nums_02.png';
import rankNum03 from './images/rank_nums/rank_nums_03.png';
import rankNum04 from './images/rank_nums/rank_nums_04.png';
import rankNum05 from './images/rank_nums/rank_nums_05.png';
import rankNum06 from './images/rank_nums/rank_nums_06.png';
import rankNum07 from './images/rank_nums/rank_nums_07.png';
import rankNum08 from './images/rank_nums/rank_nums_08.png';
import rankNum09 from './images/rank_nums/rank_nums_09.png';

import stageSpotlight from './images/minigame-spotlight.png';


import idolIconBP from './images/idol_icons/idol_icon_blackpink.jpg';
import idolIconLisa from './images/idol_icons/idol_icon_lisa.jpg';
import idolIconJisoo from './images/idol_icons/idol_icon_jisoo.jpg';
import idolIconRose from './images/idol_icons/idol_icon_rose.jpg';
import idolIconJennie from './images/idol_icons/idol_icon_jennie.jpg';




export default function MiniGameLanding() {
    // console.log("MiniGameLanding constructor started ")
    const isMountedRef = useRef();
    const gaLoadRef = useRef(false);
    // const [whiteNavi, setWhiteNavi] = useState(false);
    const { t } = useTranslation();

    const navigate = useNavigate();


    const { i18n } = useTranslation();

    let curLang = i18n.language;


    const [limitNameLength, setLimitNameLength] = useState(10);
    const [rankNumImg, setRankNumImg] = useState(
        [
            rankNum01, rankNum02, rankNum03, rankNum04, rankNum05,
            rankNum06, rankNum07, rankNum08, rankNum09
        ]
    );
    // const [iconIdolImg, setIconIdolImg] = useState(
    //     [
    //         idolIconMina, idolIconChaeyoung, idolIconDahyun,
    //         idolIconJeongyeon, idolIconJihyo, idolIconMomo,
    //         idolIconNayeon, idolIconSana, idolIconTzuyu
    //     ]
    // );

    const [miniGameLeaderData, setMiniGameLeaderData] = useState();

    const [fakeLoadState, setFakeLoadState] = useState(false);

    const fakeLoadMaskRef = useRef();

    // let intervalIdfakeLoad = null;
    let intervalIdLoadDataDelay = null;
    let intervalIdLoadData = null;


    const [idolNameShortenZH, setIdolNameShortenZH] = useState([
        'Blackpink', 'Lisa', 'Rosé',
        'Jennie', 'Jisoo'
    ]);

    // const [idolName, setIdolName] = useState(
    //   ['Chaeyoung', 'Dahyun', 'Jeongyeon',
    //   'Jihyo', 'Mina', 'Momo',
    //   'Nayeon', 'Sana', 'Tzuyu']
    // );
    // const [idolNameZh, setIdolNameZh] = useState([
    //   '彩瑛', '多賢', '定延',
    //   '志效', 'Mina', 'Momo',
    //   '娜璉', 'Sana', '子瑜',
    // ]);
    // const leaderBoardSecondRowItems =
    //     [
    //         '00', '01'
    //     ];
    const [miniGameLeaderDataSecondRow, setMiniGameLeaderDataSecondRow] = useState([]);






    let contentAnimation = null;

    const [animationWordsArray, setAnimationWordsArray] = useState([]);
    const [animationWordsEndSeconds, setAnimationWordsEndSeconds] = useState(3000);
    // const [animationWordsPauseSeconds, setAnimationWordsPauseSeconds] = useState(300);
    let animationWordsPauseSeconds = 100;

    const separateDisplayAniContent = () => {
        // Split contentAnimation into individual words and store in array
        // const wordsArray = contentAnimation.split(' ').filter(word => word.length > 0);

        // Check if content is in Chinese and split accordingly
        const isChinese = /[\u4e00-\u9fff]/.test(contentAnimation);
        const wordsArray = isChinese
            ? contentAnimation.split('').filter(char => char.trim().length > 0) // Split by character for Chinese
            : contentAnimation.split(' ').filter(word => word.length > 0); // Split by space for English

        const completeWordsArray = [...wordsArray];
        setAnimationWordsArray(completeWordsArray);
        // console.log("Home separateDisplayAniContent called, complete words array:", completeWordsArray);
        return completeWordsArray;
    }

    const animateWordsOneByOne = () => {
        if (!fakeLoadMaskRef.current || animationWordsArray.length === 0) {
            // console.log('fakeLoadMaskRef or animationWordsArray not ready');
            return;
        }

        // Create or find the text container in fakeLoadMaskRef
        let textContainer = fakeLoadMaskRef.current.querySelector('.animation-text-container');
        if (!textContainer) {
            textContainer = document.createElement('div');
            textContainer.className = 'animation-text-container';
            textContainer.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-size: 1.2rem;
        color: white;
        z-index: 10;
        margin-top: 0px;
      `;

            fakeLoadMaskRef.current.appendChild(textContainer);
        }

        // Clear existing content
        textContainer.innerHTML = '';

        // Animate each word with fade-in effect
        animationWordsArray.forEach((word, index) => {
            setTimeout(() => {
                let wordSpan = document.createElement('h5');
                wordSpan.style.cssText = `
          opacity: 0;
          display: inline-block;
          margin-right: 0.3rem;
          margin-bottom: 0.3rem;
          text-transform: uppercase;
        `;

                wordSpan.textContent = word + ' ';


                textContainer.appendChild(wordSpan);

                // GSAP fade-in animation for each word
                gsap.to(wordSpan, {
                    opacity: 1,
                    duration: 0.5,
                    ease: "power2.out",
                    onStart: () => {
                        const loadingIndicator = document.getElementsByClassName('loading-wrap-otherpage')[0];
                        if (loadingIndicator) {
                            const viewportTop = textContainer.getBoundingClientRect().top - 20;
                            loadingIndicator.style.top = viewportTop + 'px';
                        }
                    },
                    onComplete: () => {

                        if (index === animationWordsArray.length - 1) {
                            setTimeout(() => {
                                fakeLoad();
                            }, animationWordsEndSeconds); // 2000ms delay after last word animation
                        }
                    }
                });
            }, index * animationWordsPauseSeconds); // 300ms delay between each word
        });
    }

    useEffect(() => {
        if (fakeLoadMaskRef.current) {

            // if(intervalIdLoadDataDelay === null){
            //     setFakeLoadState(true);
            //     intervalIdLoadDataDelay = setInterval(loadDataServer, 2000); // delay load data after 2 seconds
            // }

            //     contentAnimation = t('miniGameAniText');
            //   if (curLang === 'zh-HK') {
            //         animationWordsPauseSeconds = 150;
            //   }

            //   separateDisplayAniContent();
            //   animateWordsOneByOne();
        }
        return () => {

        };
    }, [fakeLoadMaskRef.current]);

    // console.log('miniGameLeaderData = ')
    // console.log(miniGameLeaderData.entries)


    // var targetWidth = window.innerWidth;
    // var targetHeight = window.innerHeight;

    // const handleScroll = () => {
    //     let scroll = window.scrollY;
    //     if (scroll >= 60) {
    //         setWhiteNavi(true);
    //     } else {
    //         setWhiteNavi(false);
    //     }
    // }

    const formatNumber = (num) => {
        if (num === null || num === undefined) return num;

        // Use 'en-US' locale for standard K, M, B suffixes.
        // 'notation: "compact"' enables the abbreviation.
        // 'maximumFractionDigits: 1' limits the decimal places.
        return new Intl.NumberFormat('en-US', {
            notation: 'compact',
            maximumFractionDigits: 1
        }).format(num);
    };

    const loadDataServer = () => {
        // console.log('Starting load data server interval');
        clearInterval(intervalIdLoadDataDelay);

        const fetchData = async () => {
            try {
                // apiURLs.getLeaderboardDataURL
                const response = await fetch(apiURLs.getLeaderboardDataURL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(window.authTokenData ? { 'Authorization': `Bearer ${window.authTokenData}` } : {})
                    }
                });
                // const response = await fetch('/twice/leaderboard');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();

                if (isMountedRef.current) { // Only update state if the component is still mounted

                    const sortedLeaderByScore = [...result.entries].sort((a, b) => b.score - a.score);
                    setMiniGameLeaderData(sortedLeaderByScore);


                    setMiniGameLeaderDataSecondRow(sortedLeaderByScore.slice(3));
                    // console.log('MiniGameLanding fetchData result')
                    // console.log(sortedLeaderByScore)
                    // console.log(sortedLeaderByScore.slice(3))
                    // console.log(miniGameLeaderDataSecondRow)


                }
            } catch (error) {
                //   setError(error);
                // console.log('fetchData error')
            } finally {
                // console.log('fetchData loading finished')
                //   setLoading(false);
            }
        };

        fetchData();

        intervalIdLoadData = setInterval(fetchData, 5000); // Fetch every 5 seconds
    }

    // const handleAnimationEnd = () => {
    //     setFakeLoadState(true);
    //     intervalIdLoadDataDelay = setInterval(loadDataServer, 2000); // delay load data after 2 seconds
    // }
    // const fakeLoad = () => {
    //     if (fakeLoadMaskRef.current) {
    //         // GSAP fade out animation
    //         gsap.to(fakeLoadMaskRef.current, {
    //             opacity: 0,
    //             duration: 0.5,
    //             ease: "power2.out",
    //             onComplete: () => {
    //                 handleAnimationEnd();
    //             }
    //         });
    //     } else {
    //         // console.log('fakeLoadMaskRef.current is null');
    //     }

    //     // clearInterval(intervalIdfakeLoad);
    // }


    const matchIdolName = (tarStr) => {
        const namePrefix = tarStr ? String(tarStr).slice(0, 4) : '';
        if (curLang === 'en-HK') {
            switch (namePrefix) {
                case 'lisa': return 'LISA';
                case 'rose': return 'ROSÉ';
                case 'jenn': return 'JENNIE';
                case 'jiso': return 'JISOO';
                default: return 'GROUP'; // Fallback to Blackpink
            }
        } else {
            switch (namePrefix) {
                case 'Lisa': return idolNameShortenZH[1];
                case 'Rosé': return idolNameShortenZH[2];
                case 'Jenn': return idolNameShortenZH[3];
                case 'Jiso': return idolNameShortenZH[4];
                default: return idolNameShortenZH[0]; // Fallback to Mina
            }
        }
    }


    const matchIdolIconImg = (tarStr) => {
        const namePrefix = tarStr ? String(tarStr).slice(0, 4) : '';
        switch (namePrefix) {
            case 'lisa': return idolIconLisa;
            case 'rose': return idolIconRose;
            case 'jenn': return idolIconJennie;
            case 'jiso': return idolIconJisoo;
            default: return idolIconBP; // Fallback to Mina
        }
    }

    const matchIdolPoseImg = (tarStr) => {
        const namePrefix = tarStr ? String(tarStr).slice(0, 4) : '';
        switch (namePrefix) {
            case 'lisa': return lisaPoseIdol01;
            case 'rose': return rosePoseIdol01;
            case 'jenn': return jenniePoseIdol01;
            case 'jiso': return jisooPoseIdol01;
            default: return BPPoseIdol01; // Fallback to Mina
        }
    }

    useEffect(() => {
        isMountedRef.current = true;

        if (!gaLoadRef.current) {
            gaLoadRef.current = true;
            // Google Analytics pageview tracking
            // Fire once when the home page loads
            // gtag('event', 'view_home_page', {
            //   page_section: 'campaign_microsite'
            // });

            if (window.gtag) {
                window.gtag('event', 'view_game_page', {
                    game_name: 'taxi',
                    page_section: 'campaign_microsite'

                });
                // console.log("Games landing page gtag page_view sent");
            }
        }


        // Call fakeLoad once after a delay, not with interval
        // const timeoutId = setTimeout(() => {
        //     fakeLoad();
        // }, animationWordsEndSeconds);

        // loadDataServer();
        intervalIdLoadDataDelay = setInterval(loadDataServer, 2000); // delay load data after 2 seconds

        // Cleanup function: runs when the component unmounts
        return () => {
            isMountedRef.current = false;

            // clearTimeout(timeoutId);
            // clearInterval(intervalIdfakeLoad);
            clearInterval(intervalIdLoadDataDelay);
            clearInterval(intervalIdLoadData);

            // Stop all tweens
            // TWEEN.removeAll();
        };
    }, []); // Empty dependency array means this runs once on mount


    return (
        <div className='canvas-container'>
            {/* <SEOHelmet 
                titleKey="metaTitleMiniGame" 
                descriptionKey="metaDescriptionMiniGame" 
                canonicalPath={`/${curLang}/minigame`}
            /> */}
            {/* <div className={`${fakeLoadState ? 'canvas-container' : 'canvas-container crop'}`}> */}

            {
                // <div ref={fakeLoadMaskRef} className={`${fakeLoadState ? 'mini-game-loading-wrap display-none' : 'mini-game-loading-wrap'}`}>
                //     <LoadingIndicator quoteContent={t('miniGameAniText')} />
                // </div>
            }
            <div className="canvas-container-inner">
                {/* <AppNavi colorWhiteLogo={false} /> */}
                {/* <h1>Mini game landing</h1> */}
                <div className='mini-game-twice-wrap'>
                    <div className="mini-game-idol-dance-landing-bg-wrap">
                        <div className='mini-game-intro-idol-dance-bg-spotlight'>
                            <img className="" src={stageSpotlight} />
                        </div>
                    </div>
                    <Container>
                        <Row className='mini-game-intro-title-wrap'>
                            <Col className="">
                                <h5 className="mini-game-intro-title margin-bot-5 color-text-pink">{t('miniGameIntroTitle')}</h5>
                                <p className="color-text-pink">{t('miniGameIntroContent')}</p>
                            </Col>
                        </Row>
                    </Container>
                    <Container>
                        <Row className='mini-game-intro-btn-wrap margin-bot-30'>
                            <Col className="" xs={{ offset: 3, size: 6 }}>
                                <Button size="lg"
                                    disabled={!miniGameLeaderData}
                                    className={`${miniGameLeaderData ? 'mini-game-intro-btn' : 'mini-game-intro-btn-grey'} blink`}
                                    title='Play game' onClick={() => {
                                        navigate(`/${curLang}/minigameselect`)
                                    }}>
                                    {miniGameLeaderData ?
                                        t('miniGameBtnPlay') : t('miniGameBtnPlayLoading')}

                                </Button>
                            </Col>
                        </Row>
                    </Container>



                    <div className='mini-game-Intro-wrap'>

                        <div className='mini-game-board-top-3-wrap'>
                            <Container>
                                <Row className=''>
                                    <Col className="mini-game-board-img-idol-top3-col" xs="4">
                                        <div className="mini-game-board-idol-info-rect">
                                            <div className={`${miniGameLeaderData ?
                                                'rect-bar bar-2' : 'rect-bar bar-2 grey'}`}></div>
                                            <div className="mini-game-board-idol-info-wrap">
                                                <IconMusic />
                                                <div className="mini-game-board-img-idol-top3-count-num num2 color-text-black">
                                                    {miniGameLeaderData ?
                                                        formatNumber(miniGameLeaderData[1].score) : <Skeleton count={1} width={30} height={16} />}
                                                </div>
                                                <h6 className='mini-game-board-img-idol-name-wrap margin-bot-5 color-text-black'>
                                                    {miniGameLeaderData ?
                                                        matchIdolName(miniGameLeaderData[1].memberId) : <Skeleton count={1} width={60} height={16} />}
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="mini-game-board-img-idol-top3-wrap">
                                            {miniGameLeaderData ?
                                                <img className="mini-game-board-img-idol-top3 top2" src={
                                                    matchIdolPoseImg(miniGameLeaderData[1].memberId)
                                                } alt={miniGameLeaderData[1].name || 'Member'} /> :
                                                <Skeleton className="mini-game-board-img-idol-top3 top2" count={1} width={80} height={90} />}
                                            {/* matchIdolPoseImg */}
                                            <img className="mini-game-board-rank-num-img" src={rankNumImg[1]} alt="Rank 2" />
                                        </div>

                                    </Col>

                                    <Col className="mini-game-board-img-idol-top3-col" xs="4">
                                        <div className={`${miniGameLeaderData ? 'rect-bar bar-1' : 'rect-bar bar-1 grey'}`}></div>
                                        <div className="mini-game-board-img-idol-top3-wrap">
                                            {miniGameLeaderData ?
                                                <img className="mini-game-board-img-idol-top3" src={
                                                    matchIdolPoseImg(miniGameLeaderData[0].memberId)
                                                } alt={miniGameLeaderData[0].name || 'Member'} /> :
                                                <Skeleton className="mini-game-board-img-idol-top3" count={1} width={80} height={90} />}
                                            <img className="mini-game-board-rank-num-img" src={rankNumImg[0]} alt="Rank 2" />
                                        </div>
                                        <div className="mini-game-board-img-idol-top3-count">
                                            <IconMusic /> <div className="mini-game-board-img-idol-top3-count-num num1 color-text-black">
                                                {miniGameLeaderData ?
                                                    formatNumber(miniGameLeaderData[0].score) : <Skeleton count={1} width={30} height={16} />}
                                            </div>
                                        </div>
                                        <h6 className='mini-game-board-img-idol-name-wrap margin-bot-5 color-text-black'>
                                            {miniGameLeaderData ?
                                                matchIdolName(miniGameLeaderData[0].memberId) : <Skeleton count={1} width={60} height={16} />}
                                        </h6>
                                    </Col>

                                    <Col className="mini-game-board-img-idol-top3-col" xs="4">
                                        <div className="mini-game-board-idol-info-rect rect3-wrap">
                                            <div className={`${miniGameLeaderData ?
                                                'rect-bar bar-3' : 'rect-bar bar-3 grey'}`}></div>
                                            <div className="mini-game-board-idol-info-wrap">
                                                <IconMusic />
                                                <div className="mini-game-board-img-idol-top3-count-num num2 color-text-black">
                                                    {miniGameLeaderData ?
                                                        formatNumber(miniGameLeaderData[2].score) : <Skeleton count={1} width={30} height={16} />}
                                                </div>
                                                <h6 className='mini-game-board-img-idol-name-wrap margin-bot-5 color-text-black'>
                                                    {miniGameLeaderData ?
                                                        matchIdolName(miniGameLeaderData[2].memberId) : <Skeleton count={1} width={60} height={16} />}
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="mini-game-board-img-idol-top3-wrap">
                                            {miniGameLeaderData ?
                                                <img className="mini-game-board-img-idol-top3 top3" src={
                                                    matchIdolPoseImg(miniGameLeaderData[2].memberId)
                                                } alt={miniGameLeaderData[2].name || 'Member'} /> :
                                                <Skeleton className="mini-game-board-img-idol-top3 top3" count={1} width={80} height={90} />}
                                            <img className="mini-game-board-rank-num-img" src={rankNumImg[2]} alt="Rank 3" />
                                        </div>

                                    </Col>

                                </Row>
                            </Container>
                        </div>
                        <div className='mini-game-board-wrap'>

                            <Container>
                                <Row className=''>
                                    {miniGameLeaderDataSecondRow.map((item, index) => (
                                        <Col key={index} className="mini-game-board-rank-other-wrap" lg="4" md="6" xs="6">
                                            <Row className=''>
                                                <Col className="mini-game-board-img-idol-icon-content-wrap">
                                                    <div className="mini-game-board-img-idol-icon-wrap">
                                                        {/* {miniGameLeaderData ?
                                                            <img className="mini-game-board-img-idol-icon" src={(() => {
                                                                const namePrefix = miniGameLeaderDataSecondRow[index].name ? String(miniGameLeaderDataSecondRow[index].name).slice(0, 2) : '';
                                                                switch (namePrefix) {
                                                                    case 'My': return idolIconMina;
                                                                    case 'So': return idolIconChaeyoung;
                                                                    case 'Ki': return idolIconDahyun;
                                                                    case 'Yo': return idolIconJeongyeon;
                                                                    case 'Pa': return idolIconJihyo;
                                                                    case 'Hi': return idolIconMomo;
                                                                    case 'Im': return idolIconNayeon;
                                                                    case 'Mi': return idolIconSana;
                                                                    case 'Ch': return idolIconTzuyu;
                                                                    default: return idolIconMina; // Fallback to Mina
                                                                }
                                                            })()} alt={miniGameLeaderDataSecondRow[index].name || 'Member'} /> : <Skeleton className="mini-game-board-img-idol-top3 top2" count={1} width={40} height={40} />} */}
                                                            {miniGameLeaderData ?
                                                            <img className="mini-game-board-img-idol-icon" 
                                                            src={ matchIdolIconImg(miniGameLeaderDataSecondRow[index].memberId) } 
                                                            alt={miniGameLeaderDataSecondRow[index].name || 'Member'} /> : 
                                                            <Skeleton className="mini-game-board-img-idol-top3 top2" count={1} width={40} height={40} />
                                                            }
                                                        <img className="mini-game-board-rank-num-img-rank-other" src={rankNumImg[index + 3]} alt="Rank 2" />
                                                    </div>
                                                    <div className="mini-game-board-img-idol-content-wrap">
                                                        <h6 className="margin-bot-0 mini-game-board-img-idol-content-count">
                                                            <IconMusic />
                                                            {miniGameLeaderData ?
                                                                formatNumber(miniGameLeaderDataSecondRow[index].score) : <Skeleton count={1} width={30} height={16} />}
                                                        </h6>
                                                        <div className="mini-game-board-Content-count-row">
                                                            {miniGameLeaderData ?
                                                                matchIdolName(miniGameLeaderDataSecondRow[index].memberId) : <Skeleton count={1} width={60} height={16} />}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    ))}
                                </Row>
                            </Container>
                            <div className='corner-paper'></div>



                        </div>
                    </div>
                </div>

                {/* <TaxiGameIntro /> */}

                {/* <Footer /> */}
            </div>
        </div>
    );

}

